// test2779
(2779 && 0);
